import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const founderImg = "/img/founder.webp";

const FounderNote = () => {
  return (
    <>
      <Header />

      <section className="w-full py-10 px-4">
        <div className="max-w-7xl mt-[5rem] mx-auto">
          {/* Card Container */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              
              {/* Left Side - Founder Photo */}
              <div className="lg:w-2/5 flex-shrink-0 h-full lg:h-auto">
                <img
                  src={founderImg}
                  alt="Sumit Parashar, Founder"
                  className="w-full h-full object-cover object-center"
                />
              </div>

              {/* Right Side - Founder's Note Text */}
              <div className="lg:w-3/5 p-6 lg:p-8 flex flex-col justify-between lg:h-full">
                
                {/* Top Section - Title and Quote */}
                <div>
                  <h1 className="text-2xl lg:text-6xl font-bold tracking-widest text-blue-900 mb-1">
                    FOUNDER'S NOTE
                  </h1>
                  
                 
                </div>
                
                {/* Middle Section - Main Content */}
                <div className="flex-1 flex flex-col justify-start py-2">
                  <div className="text-sm lg:text-base text-gray-700 leading-relaxed ">
                    <p className="italic">
                  <img
                    src="/img/quote.png"
                    alt="quote"
                    className="inline-block h-4 lg:h-6 w-auto align-[0.1em] mr-2"
                  />
                      As someone who has proudly called Utah home for over 25 years, I've watched this state grow in incredible ways economically, culturally, and technologically.
                    </p>
                    <p className="italic">
                    Yet, I often felt that the story of Utah's progress was scattered across disconnected data sources, hidden behind complexity, or simply out of reach for everyday citizens.
                    </p>
                    <p>
                      That's why we built <span className="font-bold">UTahData.org </span>a platform where anyone, from students to policymakers, can explore Utah's data in a way that's visual, trustworthy, and engaging. Our goal is simple: <span className="font-bold">make Utah look good by making its data accessible.</span>
                    </p>
                    
                    <p>
                      Backed by BODEX's expertise in <span className="font-bold">AI, data management, and custom software development,</span> this project is a labor of love created by a Utah based team that believes data should not just inform, but <span className="font-bold">inspire.</span>
                    </p>
                    
                    <p >
                      Thank you for visiting. We hope this platform helps you see Utah—not just as it is, but as it's becoming.
                      <img
                        src="/img/quote-inverted.png"
                        alt="quote end"
                        className="inline-block h-4 lg:h-6 w-auto mt-2 ml-2 transform rotate-180"
                      />
                    </p>
                  </div>
                </div>
                
                {/* Bottom Section - Signature and Links */}
                <div className="mt-1">
                  {/* Signature Section */}
                  <div className="mb-2">
                    <div className="mb-1">
                      <span className="font-signature text-4xl block text-black">
                        Sumit Parashar
                      </span>
                    </div>
                    <div className="flex flex-col lg:flex-row items-start lg:items-center gap-1 lg:gap-2">
                      <div className="text-sm lg:text-base text-gray-600">
                        Founder,  <a
                          href="https://utahdata.org/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:opacity-80 transition-opacity"
                        >
                          <img
                            src="/img/footerlogo.png"
                            alt="UtahData Logo"
                            className="h-4 lg:h-5 w-auto mb-1"
                          />
                        </a> | CEO,<a
                          href="https://bodex.io/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:opacity-80 transition-opacity"
                        >
                          <img
                            src="/img/bdx.png"
                            alt="Bodex Logo"
                            className="h-4 lg:h-5 w-auto mb-1"
                          />
                        </a>
                      </div>
                      
                    
                    </div>
                  </div>
                  
                  {/* LinkedIn Connection */}
                  <div className="flex items-center gap-2 pt-1 border-t border-gray-200">
                    <span className="text-xs text-gray-600">Connect with the Founder:</span>
                    <a 
                      href="https://www.linkedin.com/in/sumitparashar?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" 
                      className="no-underline hover:opacity-80 transition-opacity" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/img/linkedin1.png"
                        alt="LinkedIn Logo"
                        className="w-5 h-5"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default FounderNote;